export class EnumTypeTranslator {
  id: string;
  description: string;

  constructor(id: string, description: string) {
    this.id = id;
    this.description = description
  }
}
export const AppEnums = {



  reportTemplateTypes: [
    new EnumTypeTranslator("HEADER", "Intestazione"),
    new EnumTypeTranslator("REPORT", "Verbale"),
    new EnumTypeTranslator("GENERIC_REPORT", "Verbale di controllo"),
    new EnumTypeTranslator("NOTICE", "Pre-Avviso"),
    new EnumTypeTranslator("COURTESY_TICKET", "Ticket cortesia parcheggio"),

    new EnumTypeTranslator("SEQUESTRATION_OWNER", "Sequestro - Custidia Proprietario"),
    new EnumTypeTranslator("SEQUESTRATION_GUARDIAN", "Sequestro - Custidia Depositeria"),
    new EnumTypeTranslator("DRIVER_DECLARATION", "Autodichiarazione del conducente"),
    new EnumTypeTranslator("CONTRIBUTORY_REPORT", "Verbale in concorso")

  ],
  licenseTypesTypes: [
    new EnumTypeTranslator("LITE", "Lite"),
    new EnumTypeTranslator("DEVICE", "Dispositivo"),
    new EnumTypeTranslator("USER", "Utente"),
    new EnumTypeTranslator("TRANSACTION", "Transazione")

  ],
  licenseModuleTypes: [
    new EnumTypeTranslator("SAFE_PATROL", "Safe Patrol"),
    new EnumTypeTranslator("CAMERA_CITY", "Camera City"),
    new EnumTypeTranslator("SAFE_PARKING", "Safe Parking"),
    new EnumTypeTranslator("SAFE_PLATE_MOBILE", "Safe Plate Mobile"),
    new EnumTypeTranslator("USE_EXTERNAL_CAMERA", "Usa camera esterna"),
  ],
  cameraTypes: [
    new EnumTypeTranslator("SAFE_PATROL_INTEGRATED", "Camera integrata"),
    new EnumTypeTranslator("SAFE_PATROL_EXTERNAL", "Camera non integrata"),
    new EnumTypeTranslator("SAFE_CITY_INTEGRATED", "Camera Fissa integrata"),
    new EnumTypeTranslator("SAFE_CITY_EXTERNAL", "Camera fissa non integrata"),

  ],

  cameraDetectionModes: [
    new EnumTypeTranslator("ONE_WAY_DIRECTIONAL", "Mono-direzionale"),
    new EnumTypeTranslator("TWO_WAY_DIRECTIONAL", "Bi-direzionale"),
  ],

  appSettingComponentTypes: [
    new EnumTypeTranslator("ADDITIONAL_COST", "Costi supplementari"),
    new EnumTypeTranslator("ARTICLE_SETTINGS", "Settaggi articoli"),

  ] as EnumTypeTranslator[],

  inspectionProviders: [
    new EnumTypeTranslator("MCTC", "Mctc"),
    new EnumTypeTranslator("ANPR", "Anagrafica Nazionale popolazione residente"),
    new EnumTypeTranslator("FLOWBIRD", "Flowbird"),
    new EnumTypeTranslator("EASY_PARK", "Easy Park"),
    new EnumTypeTranslator("PARK_MANAGER", "Parking Manager"),
  ],
};

export enum InspectionProviders {
  MCTC = "MCTC", ANPR = "ANPR", FLOWBIRD = "FLOWBIRD", EASY_PARK = "EASY_PARK", PARK_MANAGER = "PARK_MANAGER"
}
